import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import defaultProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'
import propTypes from '@/components/Form/propTypes'
import cn from '@/utilities/cn'

import Dropzone from './Dropzone'
import messages from './messages'

import './index.scss'

/**
 * @example
 * <FileDragAndDrop
 *   accept="text/csv"
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Text" />}
 *   dropZoneDescription={<FormattedMessage id="SomeDropZoneDescription" defaultMessage="Some Description" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   multiple={true}
 *   name="someField"
 *   required
 * />
 */
const FileDragAndDrop = ({ children, className, ...props }: any) => (
  <Field
    {...props}
    className={cn('form__file', className)}
    render={({ dropZoneDescription, ...field }: any) => (
      <>
        <Dropzone {...field}>
          <div className="field__dropzone">{dropZoneDescription}</div>
        </Dropzone>

        {children}
      </>
    )}
  />
)

FileDragAndDrop.displayName = 'FileDragAndDrop'

FileDragAndDrop.propTypes = {
  ...propTypes,
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.node,
  dropZoneDescription: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  multiple: PropTypes.bool,
  onDrop: PropTypes.func
}

FileDragAndDrop.defaultProps = {
  ...defaultProps,
  accept: undefined,
  children: null,
  dropZoneDescription: <FormattedMessage {...messages.dropZoneDescription} />,
  multiple: false,
  onDrop: null
}

export default FileDragAndDrop
